import axios from "axios";
import Request from "../interfaces/Request.interface"
import Response from "../interfaces/Response.interface";

const estaEnProduccion = true;


// const URLBaseLocal = "http://127.0.0.1:10000/api/solicitud-credito";
// const URLBaseLocal = "http://192.168.1.74:10000/api/solicitud-credito";
const URLBaseLocal = `http://${window.location.hostname}:10000/api/solicitud-credito`;

const URLBaseProduccion = "https://sistema-solicitud-credito.tzedaka.com.mx/api/solicitud-credito";


const executeRequest = async (request: Request): Promise<Response> => {
    
    let response: any;
    let data: Response;

    try {
        data = await axios({
            url: request.url,
            method: request.metodo,
            headers: request.headers,
            data: request.data,
            params : request.params
        });
        
        response = {
            error: data.data.error,
            message: data.data.message,
            data: data.data
        };

    } catch (error: any) {

        console.error("Mensaje:", error.message);
        console.error("Código:", error.code);
        console.error("URL:", error.config?.url);
        console.error("Método:", error.config?.method);
        console.error("Payload:", error.config?.data);
        console.error("Stack:", error.stack);

        response = {
            error: true,
            data: {
                error: true,
                message: error
            }
        };

    }

    return response;

};

const ApiConfig = {
    URLBase: estaEnProduccion ? URLBaseProduccion : URLBaseLocal,
    executeRequest
};

export default ApiConfig;